export function usesGatewayStackLayout($modal) {
    return $modal.find('.mgr-pledge-gateway-stack').length > 0;
}
